import React from 'react';

const CardShimmer = ({
  className = '',
  showImage = true,
  imageAspectRatio = 'aspect-video',
  titleLines = 1,
  descriptionLines = 2,
  rounded = 'rounded-lg',
}) => {
  return (
    <div
      className={`bg-[#1A1C20] ${rounded} overflow-hidden border border-gray-800 ${className}`}
    >
      {/* Image Shimmer */}
      {showImage && (
        <div
          className={`relative overflow-hidden bg-gradient-to-r from-[#1A1C20] via-[#25272C] to-[#1A1C20] ${imageAspectRatio}`}
        >
          <div className="absolute inset-0 -translate-x-full animate-shimmer">
            <div className="h-full w-full bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
          </div>
        </div>
      )}

      {/* Text Content Shimmer */}
      <div className="p-4 space-y-3">
        {/* Title placeholder(s) */}
        {Array.from({ length: titleLines }).map((_, index) => (
          <div
            key={`title-${index}`}
            className={`h-4 bg-gradient-to-r from-[#1A1C20] via-[#25272C] to-[#1A1C20] rounded relative overflow-hidden ${
              index === titleLines - 1 ? 'w-3/4' : 'w-full'
            }`}
          >
            <div
              className="absolute inset-0 -translate-x-full animate-shimmer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="h-full w-full bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
            </div>
          </div>
        ))}

        {/* Description placeholder(s) */}
        {Array.from({ length: descriptionLines }).map((_, index) => (
          <div
            key={`desc-${index}`}
            className={`h-3 bg-gradient-to-r from-[#1A1C20] via-[#25272C] to-[#1A1C20] rounded relative overflow-hidden ${
              index === descriptionLines - 1 ? 'w-5/6' : 'w-full'
            }`}
          >
            <div
              className="absolute inset-0 -translate-x-full animate-shimmer"
              style={{ animationDelay: `${(titleLines + index) * 0.1 + 0.2}s` }}
            >
              <div className="h-full w-full bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardShimmer;
